import { ReactElement } from 'react'
import { Box } from '@mui/material'
import NotificationReminder from './NotificationReminder'
import OpenLastThreadButton from './OpenLastThreadButton'

interface Props {
  projectId: string
  threadId: string
  onSelectThread: (threadId: string, model: string | null | undefined) => void
}

/**
 * Shown over a new, empty chat: the notification reminder at the top, and
 * back to the last chat in the middle.
 */
const EmptyChatHints = ({ projectId, threadId, onSelectThread }: Props): ReactElement => (
  <Box
    sx={{
      position: 'absolute',
      inset: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: 2,
      // The chat's message field stays usable around the hints.
      pointerEvents: 'none',
      '& > *': { pointerEvents: 'auto' },
    }}
  >
    <Box
      sx={{
        position: 'absolute',
        top: 16,
        left: 16,
        right: 16,
        display: 'flex',
        justifyContent: 'center',
        pointerEvents: 'none',
        '& > *': { pointerEvents: 'auto' },
      }}
    >
      <NotificationReminder />
    </Box>
    <OpenLastThreadButton
      projectId={projectId}
      threadId={threadId}
      onSelectThread={onSelectThread}
    />
  </Box>
)

export default EmptyChatHints
